import { getDetectByHour } from "./../api/detect";
import { useQuery } from "@tanstack/react-query";
import { DateFilter } from "../types/types";

interface PropsParams extends DateFilter {
  resetFetch?: () => void;
  fetch: boolean;
  ownerID?: string;
  area: string;
  groupId?: string;
  mobility_code?: number;
  mobility_seq?: number;
}
const useGetDetectByHour = ({
  startDate,
  endDate,
  ownerID,
  area,
  groupId,
  mobility_code,
  mobility_seq,
}: PropsParams) => {
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: [
      "detect",
      `detectByHour`,
      `ownerID-${ownerID}`,
      `startDate-${startDate}`,
      `endDate-${endDate}`,
      `area-${area}`,
      `groupId-${groupId}`,
      `mobility_code-${mobility_code}`,
      `mobility_seq-${mobility_seq}`,
    ],
    queryFn: () =>
      getDetectByHour({ startDate, endDate, ownerID, area, groupId, mobility_code, mobility_seq }),

    enabled: true,
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 0,
  });
  return { data, isLoading, isSuccess };
};

export default useGetDetectByHour;
